import { Uppdrag } from "types/uppdrag.type";
import { ContentContainer, ShadowCard } from "components/ShadowCard";
import BasicTable from "components/basicTable/BasicTable";
import { dateToYearMonthDay } from "helpers/date";

import { useQuery } from "@tanstack/react-query";
import { getWasteList } from "api/waste.api";
import { Link } from "components/Link";
import { NvRapporteringStatusTag } from "components/NvRapporteringStatusTag";
import { getRelevantWasteWeightToString } from "types/waste.type";
import { Tips } from "components/Tips";

type Props = {
  uppdrag: Uppdrag;
};
export const Naturvardsverket = ({ uppdrag }: Props) => {
  const wasteQuery = useQuery(
    getWasteList({
      onlyNv: true,
      limit: 40,
      offset: 0,
      uppdragId: uppdrag.id,
    }),
  );

  return (
    <ShadowCard>
      <ContentContainer>
        <Tips
          id="99c72ec4-19bb-47a6-b4b9-2bf021fd0cc4"
          paragraphs={["Klicka på en status för att öppna rapporteringen"]}
        />
        <BasicTable>
          <BasicTable.THead>
            <BasicTable.TH>Avfall</BasicTable.TH>
            <BasicTable.TH>Transportdatum</BasicTable.TH>
            <BasicTable.TH>Transportrapportering</BasicTable.TH>
            <BasicTable.TH>Ombudsrapportering</BasicTable.TH>
          </BasicTable.THead>
          <BasicTable.TBody>
            {(wasteQuery.data?.items ?? []).map((waste) => (
              <BasicTable.TR key={waste.id}>
                <BasicTable.TD>{`${waste.wasteCode.codePretty}, ${getRelevantWasteWeightToString(waste)}`}</BasicTable.TD>
                <BasicTable.TD>
                  {dateToYearMonthDay(waste.transportSedel.timeOfDepartureUtc)}
                </BasicTable.TD>
                <BasicTable.TD>
                  <Link
                    to="/app/avfallsregistret/rapportera-transport"
                    search={{ wasteid: waste.id }}
                  >
                    <NvRapporteringStatusTag
                      status={waste.transportRapporteringStatus}
                      isButton
                    />
                  </Link>
                </BasicTable.TD>
                <BasicTable.TD>
                  <Link
                    to="/app/avfallsregistret/rapportera-som-ombud"
                    search={{ wasteid: waste.id }}
                  >
                    <NvRapporteringStatusTag
                      status={waste.ombudsRapporteringStatus}
                      isButton
                    />
                  </Link>
                </BasicTable.TD>
              </BasicTable.TR>
            ))}
          </BasicTable.TBody>
        </BasicTable>
      </ContentContainer>
    </ShadowCard>
  );
};
